// src/pages/GetStarted.tsx
import React from "react";
// Remove Chakra UI imports
// import { Box, Button, Heading, VStack, Text, Container, Stack, SimpleGrid, Flex, Spacer, Link } from "@chakra-ui/react";
// import { keyframes } from "@emotion/react"; // Keep if any animations remain
import { useNavigate } from "react-router-dom";

// Remove or keep keyframes if needed for other elements
// const gradientAnimation = keyframes`...`;

const GetStarted: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col items-center bg-white">
      {/* Header */}
      {/* Refined header styling to match the image */}
      <header className="fixed top-0 left-0 right-0 z-10 w-full px-4 md:px-8 py-4 flex items-center bg-white shadow-sm">
        {/* Zensight Branding */}
        {/* Adjusted branding text style to match the image header */}
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            navigate("/");
          }}
          className="flex items-center no-underline"
        >
          <span className="font-roboto text-xl md:text-2xl font-bold bg-gradient-to-r from-[#FBD282] to-[#B59143] text-transparent bg-clip-text">
            Zen
          </span>
          <span className="font-roboto text-xl md:text-2xl font-bold text-gray-900">
            {" "}
            {/* Darker gray for Sight */}
            Sight
          </span>
        </a>
        <div className="flex-grow"></div>{" "}
        {/* Pushes the nav items to the right */}
        {/* Navigation */}
        <div className="flex items-center space-x-4">
          {/* Adjusted Sign In link color */}
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              navigate("/login");
            }}
            className="text-gray-700 hover:underline text-base"
          >
            Sign In
          </a>
          <button
            className="px-4 py-2 text-sm font-bold bg-gradient-to-r from-[#FBD282] to-[#B59143] text-black rounded-full hover:opacity-90 shadow-md transition-all duration-300 ease-in-out"
            onClick={() => navigate("/register")}
          >
            Get Started
          </button>
        </div>
      </header>

      {/* Hero Section - Styled for text left, image right with reduced gap */}
      {/* Ensure content is centered vertically in the remaining space */}
      {/* Adjusted gap and container width */}
      <div className="flex-grow w-full flex items-center justify-center pt-24 pb-10 md:pt-32 md:pb-16">
        {/* Reduced max-width and adjusted padding/margins */}
        <div className="container mx-auto px-4 md:px-0 max-w-6xl">
          {" "}
          {/* Using xl for a wider container */}
          {/* Adjusted gap (gap-6 for medium screens and above) */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center">
            {" "}
            {/* Adjusted gap */}
            {/* Hero Text Content (Left Side) */}
            <div className="text-center md:text-left">
              {/* Main Heading: Welcome to Zensight */}
              <h1 className="text-4xl md:text-6xl font-extrabold leading-tight tracking-wide text-gray-900 mb-4">
                {" "}
                Welcome to
                <br />
                <span className="bg-gradient-to-r from-[#FBD282] to-[#B59143] text-transparent bg-clip-text">Zensight</span>
              </h1>

              {/* New Subtitle / Additional Text */}
              <p className="text-base md:text-lg text-gray-700 mt-2 md:mt-3 max-w-xl md:max-w-full leading-relaxed mx-auto md:mx-0">
                Empower your workflows with Zensight's cutting edge solutions
              </p>

              {/* CTA Button (Main) */}
              <button
                className="mt-8 px-8 py-3 md:py-4 text-xl font-bold bg-gradient-to-r from-[#FBD282] to-[#B59143] text-black rounded-full hover:opacity-90 shadow-lg transition-all duration-300 ease-in-out"
                onClick={() => navigate("/register")}
              >
                Get Started →
              </button>
            </div>
            {/* Hero Image (Right Side) */}
            <div className="flex justify-center md:justify-end">
              {/* Added max-width and height to the image for better control */}
              <img
                src="/bg.png"
                alt="Zensight brand illustration"
                className="max-w-md lg:max-w-lg h-auto"
              />{" "}
              {/* Adjust size as needed */}
            </div>
          </div>
        </div>
      </div>

      {/* Features Section (Reintroduced and improved) */}
      {/* Added a distinct background and padding */}
      <div className="w-full bg-gray-100 py-16">
        <div className="container mx-auto px-4 md:px-0 max-w-screen-xl">
          {" "}
          {/* Main container for features */}
          {/* Section Heading */}
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-4">
              How Zensight Works
            </h2>
            <p className="text-lg text-gray-700 max-w-2xl mx-auto">
              Our simple process helps you achieve your goals.
            </p>
          </div>
          {/* Feature Cards Container - Grid layout */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {" "}
            {/* 3 columns on medium screens and above */}
            {/* Feature Card 1: Define Goals */}
            <div className="bg-white p-8 rounded-lg shadow-sm hover:-translate-y-1 hover:shadow-md transition-all duration-300 ease-in-out flex flex-col items-center text-center">
              {" "}
              {/* Centered content */}
              {/* Icon */}
              <div className="w-14 h-14 bg-gradient-to-br from-[#FBD282] to-[#B59143] rounded-full flex items-center justify-center mb-4">
                {/* Icon goes here */}
                <span className="text-white text-3xl">🎯</span>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">
                Define Your Goals
              </h3>
              <p className="text-gray-600">
                Set clear, measurable objectives for your team and projects.
              </p>
            </div>
            {/* Feature Card 2: Track Progress */}
            <div className="bg-white p-8 rounded-lg shadow-sm hover:-translate-y-1 hover:shadow-md transition-all duration-300 ease-in-out flex flex-col items-center text-center">
              {" "}
              {/* Centered content */}
              {/* Icon */}
              <div className="w-14 h-14 bg-gradient-to-br from-green-400 to-green-600 rounded-full flex items-center justify-center mb-4">
                {/* Icon goes here */}
                <span className="text-white text-3xl">📊</span>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">
                Track Progress
              </h3>
              <p className="text-gray-600">
                Monitor real-time performance with comprehensive analytics.
              </p>
            </div>
            {/* Feature Card 3: Optimize Results */}
            <div className="bg-white p-8 rounded-lg shadow-sm hover:-translate-y-1 hover:shadow-md transition-all duration-300 ease-in-out flex flex-col items-center text-center">
              {" "}
              {/* Centered content */}
              {/* Icon */}
              <div className="w-14 h-14 bg-gradient-to-br from-blue-400 to-blue-600 rounded-full flex items-center justify-center mb-4">
                {/* Icon goes here */}
                <span className="text-white text-3xl">✨</span>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">
                Optimize Results
              </h3>
              <p className="text-gray-600">
                Use insights to refine strategies and achieve better outcomes.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GetStarted;
